import NotificationsScreen from './NotificationsScreen';

export default NotificationsScreen;
